module.exports = __webpack_public_path__ + "static/media/solo33.72045af1.JPG";